module.exports = __webpack_public_path__ + "static/img/pearl-cotton.c13a3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/pearl-cotton.png
// module id = qWSN
// module chunks = 2